import React, { useState ,useEffect} from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import {
  Box,
  Card,
   Tabs,
  Tab,
  Backdrop,
  CardContent,
  Typography,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Grid,
  Paper,
  Divider,
  Alert,
  Snackbar,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,CircularProgress
} from '@mui/material';
import {
  Add as AddIcon,
  Search as SearchIcon,
  Assignment as AssignmentIcon,
  BugReport as BugReportIcon,
  Group as GroupIcon,
  DateRange as DateRangeIcon,
  Person as PersonIcon,
  FilterList as FilterListIcon,
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import { PhotoFilter as EnhancementIcon } from '@mui/icons-material';
import { useSelector } from "react-redux";
import axios from 'axios';
import { useAuthToken } from "../TokenContext";

// Mock data for demonstration
const mockTickets = [
  {
    id: 1,
    name: 'Fix login authentication bug',
    description: 'Users are unable to login with Google OAuth integration. Error occurs on redirect.',
    type: 'issue',
    dueDate: '2025-06-10',
    status: 'available',
    createdBy: 'John Manager',
    createdAt: '2025-06-01',
    priority: 'high',
    assignedTo: null
  },
  {
    id: 2,
    name: 'Add dark mode feature',
    description: 'Implement dark mode toggle in user settings with theme persistence',
    type: 'enhancement',
    dueDate: '2025-06-15',
    status: 'in-progress',
    createdBy: 'Sarah Manager',
    createdAt: '2025-06-02',
    priority: 'medium',
    assignedTo: 'Alex Developer'
  },
  {
    id: 3,
    name: 'Database optimization',
    description: 'Optimize database queries for better performance on user dashboard',
    type: 'enhancement',
    dueDate: '2025-06-20',
    status: 'available',
    createdBy: 'Mike Manager',
    createdAt: '2025-05-30',
    priority: 'low',
    assignedTo: null
  }
];

// ==============================================
// MANAGER SIDE COMPONENTS
// ==============================================

export const ManagerTicketView = ({ collapsed }) => {
  const [activeTab, setActiveTab] = useState('manage'); // Default to 'manage'
  const [tickets, setTickets] = useState(mockTickets);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleTicketCreated = (newTicket) => {
    setTickets(prev => [...prev, newTicket]);
    setActiveTab('manage'); // Switch to manage tab after creation
  };

  // Tab configuration
  const tabs = [
    {
      value: 'create',
      label: 'Create Ticket',
      icon: <AddIcon />,
      component: <CreateTicketButton onTicketCreated={handleTicketCreated} collapsed={collapsed} />
    },
    {
      value: 'manage',
      label: 'Manage Tickets', 
      icon: <AssignmentIcon />,
      component: <ManagerTicketDashboard tickets={tickets} setTickets={setTickets} collapsed={collapsed} />
    }
  ];

  return (
    <Box sx={{ 
      width: `calc(100vw - ${collapsed ? '60px' : '240px'})`,
      marginLeft: collapsed ? '60px' : '240px',
      p: 3,
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }}>
      {/* Horizontal Tabs */}
      <Tabs 
        value={activeTab}
        onChange={handleTabChange}
        variant="fullWidth"
        sx={{
          mb: 3,
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiTabs-indicator': {
            height: 4,
            borderRadius: '4px 4px 0 0'
          }
        }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            value={tab.value}
            label={tab.label}
            icon={tab.icon}
            iconPosition="start"
            sx={{
              textTransform: 'none',
              fontSize: '0.875rem',
              fontWeight: activeTab === tab.value ? 'bold' : 'normal',
              minHeight: 48
            }}
          />
        ))}
      </Tabs>

      {/* Tab Content - Only one shown at a time */}
      <Box sx={{ flex: 1 }}>
        {tabs.map((tab) => (
          <Box 
            key={tab.value}
            role="tabpanel"
            hidden={activeTab !== tab.value}
            sx={{
              height: '100%',
              display: activeTab === tab.value ? 'block' : 'none'
            }}
          >
            {tab.component}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

// Create Ticket Component - Manager View (for Home Screen)
// Create Ticket Component - Manager View (for Home Screen) with API Integration
// Make sure you have these imports at the top of your file:
// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import axios from 'axios';
// import { Box, Paper, TextField, Button, Grid, Typography, FormControl, InputLabel, Select, MenuItem, Chip, InputAdornment, Snackbar, Alert } from '@mui/material';
// import { AssignmentIcon, BugReportIcon, EnhancementIcon, PersonIcon, DateRangeIcon, GroupIcon } from '@mui/icons-material';

// Add missing imports at the top of the component

// Add missing imports at the top of the component

export const CreateTicketButton = ({ onTicketCreated, collapsed }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user } = useSelector(state => state.auth);
  const token = useAuthToken();
  
  // New state for pods and pod members
  const [pods, setPods] = useState([]);
  const [selectedPodId, setSelectedPodId] = useState('');
  const [podMembers, setPodMembers] = useState([]);
  const [error, setError] = useState('');
  const [loadingPods, setLoadingPods] = useState(false);
  
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    type: '',
    dueDate: '',
    priority: 'medium',
    assignedTo: '',
    Candidate_Name: '', // Add this to store candidate name
    status: 'available',
    pod_id: '',
    managerId: '',
    clientCode: ''
  });
  const [errors, setErrors] = useState({});

  // Fetch pods when component mounts
  useEffect(() => {
    console.log('useEffect triggered for fetchPods');
    console.log('User:', user);
    console.log('Token:', token);
    console.log('User emp_id:', user?.data?.[0]?.emp_id);
    
    if (user?.data?.[0]?.emp_id && token) {
      console.log('Calling fetchPods...');
      fetchPods();
    } else {
      console.log('Missing user data or token, not calling fetchPods');
    }
  }, [user, token]);

  // Fetch pod members when a pod is selected
  useEffect(() => {
    if (selectedPodId) {
      fetchPodMembers();
    } else {
      setPodMembers([]);
      // Clear assigned to if pod is deselected
      if (formData.assignedTo) {
        handleInputChange('assignedTo', '');
        handleInputChange('Candidate_Name', '');
      }
    }
  }, [selectedPodId]);

  const fetchPods = async () => {
    console.log('fetchPods function called');
    console.log('Environment variable:', process.env.REACT_APP_CLIENT_GETMULTIPLECLIENTPODS);
    
    if (!user?.data?.[0]?.emp_id) {
      console.log('No emp_id found');
      return;
    }
    if (!token) {
      console.log('No token found');
      return;
    }

    setLoadingPods(true);
    try {
      console.log('Making API call to fetch pods...');
      const requestData = { clientID: user.data[0].emp_id };
      console.log('Request data:', requestData);
      console.log('Headers:', { Authorization: token });

      const response = await axios.post(
        process.env.REACT_APP_CLIENT_GETMULTIPLECLIENTPODS,
        requestData,
        { headers: { Authorization: token } }
      );
      
      console.log('Pods API response:', response.data);
      
      if (response.data?.data?.podDetails) {
        console.log('Setting pods:', response.data.data.podDetails);
        setPods(response.data.data.podDetails);
      } else {
        console.log('No podDetails found in response');
      }
    } catch (err) {
      console.error('Error fetching pods:', err);
      console.error('Error details:', err.response?.data);
      setError('Failed to fetch pods');
    } finally {
      setLoadingPods(false);
    }
  };

  const fetchPodMembers = async () => {
    if (!selectedPodId || !token) return;
    try {
      const response = await axios.post(
        process.env.REACT_APP_CLIENT_CLIENTFETCHPODMEMBERS,
        { pod_Id: selectedPodId },
        { headers: { Authorization: token } }
      );
      if (response.data?.data) {
        // Store pod members with both ID and name
        const members = response.data.data.map(member => ({
          id: member.c_id,
          name: member.firstName
        }));
        setPodMembers(members);
      }
    } catch (err) {
      setError('Failed to fetch pod members');
      console.error('Error fetching pod members:', err);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handlePodChange = (podId) => {
    setSelectedPodId(podId);
    handleInputChange('pod_id', podId);
    // Clear assigned to when pod changes
    handleInputChange('assignedTo', '');
    handleInputChange('Candidate_Name', '');
  };

  // Handle candidate selection - store both ID and name
  const handleCandidateChange = (candidateId) => {
    const selectedCandidate = podMembers.find(member => member.id === candidateId);
    handleInputChange('assignedTo', candidateId);
    handleInputChange('candidate_Name', selectedCandidate?.name || '');
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Ticket name is required';
    if (!formData.description.trim()) newErrors.description = 'Description is required';
    if (!formData.type) newErrors.type = 'Type is required';
    if (!formData.dueDate) newErrors.dueDate = 'Due date is required';
    
    const selectedDate = new Date(formData.dueDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (selectedDate < today) {
      newErrors.dueDate = 'Due date cannot be in the past';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const createTicketAPI = async (ticketData) => {
    try {
      // Format date for API - convert YYYY-MM-DD to ISO format if needed
      const formatDateForAPI = (dateStr) => {
        if (!dateStr) return null;
        try {
          // If it's YYYY-MM-DD format, convert to ISO
          if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return new Date(dateStr + 'T00:00:00.000Z').toISOString();
          }
          // If it's already ISO, return as-is
          return dateStr;
        } catch (e) {
          console.error('Error formatting date for API:', dateStr, e);
          return dateStr;
        }
      };

      const formattedDueDate = formatDateForAPI(ticketData.dueDate);
      console.log('Original due date:', ticketData.dueDate);
      console.log('Formatted due date for API:', formattedDueDate);

      const requestBody = {
        ticket_name: ticketData.name,
        ticket_description: ticketData.description,
        ticket_type: ticketData.type,
        ticket_priority: ticketData.priority,
        assigned_to: ticketData.assignedTo || null,
        assigned_to_name: ticketData.candidate_Name || null, // Send candidate name too
        status: ticketData.status,
        due_date: formattedDueDate,
        pod_id: ticketData.pod_id,
        manager_id: user.data[0].emp_id,
        client_code: user.data[0].client_code
      };

      console.log('Create ticket API request body:', requestBody);

      const response = await fetch(process.env.REACT_APP_CLIENT_CREATETICKETTALENT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
           'Authorization': token 
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error creating ticket:', error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    console.log('Form submitted with data:', formData);
    console.log('Status being sent:', formData.status);
    console.log('Due date being sent:', formData.dueDate);
    
    const isValid = validateForm();
    console.log('Form validation result:', isValid);
    console.log('Validation errors:', errors);
    
    if (!isValid) {
      console.log('Form validation failed, not calling API');
      return;
    }

    console.log('Validation passed, calling API...');
    setIsSubmitting(true);

    try {
      const apiResponse = await createTicketAPI(formData);
      console.log('API response:', apiResponse);
      
      // Show success message
      setSnackbarMessage('Ticket created successfully!');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      
      // Reset form
      handleReset();
      
      // Call the callback if provided
      if (onTicketCreated) {
        onTicketCreated(apiResponse);
      }
    } catch (error) {
      console.error('Failed to create ticket:', error);
      setSnackbarMessage('Failed to create ticket. Please try again.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Pre-populate fields from user data
  useEffect(() => {
    if (user?.data?.[0]) {
      setFormData(prev => ({
        ...prev,
        managerId: user.data[0].emp_id || '',
        clientCode: user.data[0].client_code || ''
      }));
    }
  }, [user]);

  const handleReset = () => {
    setFormData({
      name: '',
      description: '',
      type: '',
      dueDate: '',
      priority: 'medium',
      assignedTo: '',
      candidate_Name: '',
      status: 'available',
      pod_id: '',
      managerId: user?.data?.[0]?.emp_id || '',
      clientCode: user?.data?.[0]?.client_code || ''
    });
    setErrors({});
    setSelectedPodId('');
    setPodMembers([]);
  };

  return (
    <Box sx={{ 
      p: 3,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%'
    }}>
      <Box 
        display="flex" 
        alignItems="center" 
        gap={2} 
        mb={4}
        sx={{ width: '100%', maxWidth: 800 }}
      >
        <AssignmentIcon color="primary" fontSize="large" />
        <Typography variant="h4" component="h1">
          Create New Ticket
        </Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ width: '100%', maxWidth: 800, mb: 2 }}>
          {error}
        </Alert>
      )}

      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 800 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Ticket Name"
                value={formData.name}
                onChange={(e) => handleInputChange('name', e.target.value)}
                error={!!errors.name}
                helperText={errors.name}
                variant="outlined"
                required
                disabled={isSubmitting}
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                multiline
                rows={6}
                value={formData.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
                error={!!errors.description}
                helperText={errors.description}
                variant="outlined"
                required
                disabled={isSubmitting}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.type} required>
                <InputLabel>Type</InputLabel>
                <Select
                  value={formData.type}
                  onChange={(e) => handleInputChange('type', e.target.value)}
                  label="Type"
                  disabled={isSubmitting}
                >
                  <MenuItem value="issue">
                    <Box display="flex" alignItems="center" gap={1}>
                      <BugReportIcon fontSize="small" color="error" />
                      Issue
                    </Box>
                  </MenuItem>
                  <MenuItem value="enhancement">
                    <Box display="flex" alignItems="center" gap={1}>
                      <EnhancementIcon fontSize="small" color="primary" />
                      Enhancement
                    </Box>
                  </MenuItem>
                </Select>
                {errors.type && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                    {errors.type}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Priority</InputLabel>
                <Select
                  value={formData.priority}
                  onChange={(e) => handleInputChange('priority', e.target.value)}
                  label="Priority"
                  disabled={isSubmitting}
                >
                  <MenuItem value="low">Low</MenuItem>
                  <MenuItem value="medium">Medium</MenuItem>
                  <MenuItem value="high">High</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Pod Selection */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Select Pod</InputLabel>
                <Select
                  value={selectedPodId}
                  onChange={(e) => handlePodChange(e.target.value)}
                  label="Select Pod"
                  disabled={isSubmitting || loadingPods}
                >
                  <MenuItem value="">
                    <Box display="flex" alignItems="center" gap={1}>
                      <GroupIcon fontSize="small" color="action" />
                      No Pod Selected
                    </Box>
                  </MenuItem>
                  {pods.map((pod) => (
                    <MenuItem key={pod.id} value={pod.id}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <GroupIcon fontSize="small" color="primary" />
                        {pod.podName}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
                {loadingPods && (
                  <Typography variant="caption" color="primary" sx={{ mt: 0.5, ml: 2 }}>
                    Loading pods...
                  </Typography>
                )}
              </FormControl>
            </Grid>

            {/* Assigned To - Now dynamically populated with pod members */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Assigned To</InputLabel>
                <Select
                  value={formData.assignedTo}
                  onChange={(e) => handleCandidateChange(e.target.value)}
                  label="Assigned To"
                  disabled={isSubmitting || !selectedPodId}
                >
                  <MenuItem value="">
                    <Box display="flex" alignItems="center" gap={1}>
                      <PersonIcon fontSize="small" color="action" />
                      Unassigned
                    </Box>
                  </MenuItem>
                  {podMembers.map((member) => (
                    <MenuItem key={member.id} value={member.id}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <PersonIcon fontSize="small" color="primary" />
                        {member.name}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
                {!selectedPodId && (
                  <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, ml: 2 }}>
                    Please select a pod first to see available members
                  </Typography>
                )}
                {formData.candidate_Name && (
                  <Typography variant="caption" color="primary" sx={{ mt: 0.5, ml: 2 }}>
                    Selected: {formData.candidate_Name}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  value={formData.status}
                  onChange={(e) => handleInputChange('status', e.target.value)}
                  label="Status"
                  disabled={isSubmitting}
                >
                  <MenuItem value="available">
                    <Box display="flex" alignItems="center" gap={1}>
                      <Chip label="AVAILABLE" color="success" size="small" variant="outlined" />
                    </Box>
                  </MenuItem>
                  <MenuItem value="Open">
                    <Box display="flex" alignItems="center" gap={1}>
                      <Chip label="OPEN" color="info" size="small" variant="outlined" />
                    </Box>
                  </MenuItem>
                  <MenuItem value="in-progress">
                    <Box display="flex" alignItems="center" gap={1}>
                      <Chip label="IN PROGRESS" color="warning" size="small" variant="outlined" />
                    </Box>
                  </MenuItem>
                  <MenuItem value="completed">
                    <Box display="flex" alignItems="center" gap={1}>
                      <Chip label="COMPLETED" color="success" size="small" variant="outlined" />
                    </Box>
                  </MenuItem>
                  <MenuItem value="on-hold">
                    <Box display="flex" alignItems="center" gap={1}>
                      <Chip label="ON HOLD" color="warning" size="small" variant="outlined" />
                    </Box>
                  </MenuItem>
                  <MenuItem value="Pending">
                    <Box display="flex" alignItems="center" gap={1}>
                      <Chip label="PENDING" color="info" size="small" variant="outlined" />
                    </Box>
                  </MenuItem>
                  <MenuItem value="cancelled">
                    <Box display="flex" alignItems="center" gap={1}>
                      <Chip label="CANCELLED" color="error" size="small" variant="outlined" />
                    </Box>
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Due Date"
                type="date"
                value={formData.dueDate}
                onChange={(e) => handleInputChange('dueDate', e.target.value)}
                error={!!errors.dueDate}
                helperText={errors.dueDate}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <DateRangeIcon color="action" />
                    </InputAdornment>
                  )
                }}
                required
                disabled={isSubmitting}
              />
            </Grid>
            
            <Grid item xs={12}>
              <Box display="flex" justifyContent="flex-end" gap={2} mt={4}>
                <Button 
                  onClick={handleReset} 
                  variant="outlined" 
                  size="large"
                  sx={{ minWidth: 120 }}
                  disabled={isSubmitting}
                >
                  Reset
                </Button>
                <Button 
                  type="submit" 
                  variant="contained" 
                  size="large"
                  sx={{ minWidth: 120 }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Creating...' : 'Create Ticket'}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Paper>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setSnackbarOpen(false)} 
          severity={snackbarSeverity}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

// Manager Dashboard - View All Tickets
// Manager Dashboard - View All Tickets with API Integration
// Add missing imports at the top of the component

// Add missing imports at the top of the component

export const ManagerTicketDashboard = ({ collapsed }) => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // Add missing severity state
  const [candidates, setCandidates] = useState([]);
  const [updating, setUpdating] = useState(false);
  
  // Add new states for pod-based candidate fetching
  const [pods, setPods] = useState([]);
  const [allPodMembers, setAllPodMembers] = useState([]);
  const [loadingCandidates, setLoadingCandidates] = useState(false);
  
  const { user } = useSelector(state => state.auth);
  const token = useAuthToken();

  // API Base URL - Update this with your actual domain
  const API_BASE_URL = process.env.REACT_APP_CLIENT_FETCHTICKETTALENT;

  // Fetch tickets and candidates on component mount
  useEffect(() => {
    if (user?.data?.[0]?.emp_id && token) {
      // Fetch pod members first, then tickets
      fetchPodsAndMembers().then(() => {
        fetchTickets();
      });
    }
  }, [user, token]);

  // Remove the problematic useEffect that was causing conflicts
  // The candidate_Name will be handled properly in fetchTickets and handleSaveEdit

  // Add function to fetch pods and all members for candidate selection
  const fetchPodsAndMembers = async () => {
    setLoadingCandidates(true);
    try {
      // Fetch pods
      const podsResponse = await axios.post(
        process.env.REACT_APP_CLIENT_GETMULTIPLECLIENTPODS,
        { clientID: user.data[0].emp_id },
        { headers: { Authorization: token } }
      );
      
      if (podsResponse.data?.data?.podDetails) {
        setPods(podsResponse.data.data.podDetails);
        
        // Fetch members for each pod
        const allMembers = [];
        for (const pod of podsResponse.data.data.podDetails) {
          try {
            const membersResponse = await axios.post(
              process.env.REACT_APP_CLIENT_CLIENTFETCHPODMEMBERS,
              { pod_Id: pod.id },
              { headers: { Authorization: token } }
            );
            
            if (membersResponse.data?.data) {
              const podMembers = membersResponse.data.data.map(member => ({
                id: member.c_id,
                name: member.firstName,
                podId: pod.id,
                podName: pod.podName
              }));
              allMembers.push(...podMembers);
            }
          } catch (err) {
            console.error(`Error fetching members for pod ${pod.id}:`, err);
          }
        }
        
        // Remove duplicates based on id
        const uniqueMembers = allMembers.filter((member, index, self) => 
          index === self.findIndex(m => m.id === member.id)
        );
        
        setAllPodMembers(uniqueMembers);
        setCandidates(uniqueMembers); // Use pod members as candidates
      }
    } catch (err) {
      console.error('Error fetching pods and members:', err);
      // Fallback to the original method if pod fetching fails
      fetchCandidatesFromTickets();
    } finally {
      setLoadingCandidates(false);
    }
  };

  // Fallback method - extract candidates from existing tickets
  const fetchCandidatesFromTickets = () => {
    const uniqueCandidates = [];
    const candidateMap = new Map();
    
    tickets.forEach(ticket => {
      if (ticket.assignedTo && ticket.candidate_Name && !candidateMap.has(ticket.assignedTo)) {
        candidateMap.set(ticket.assignedTo, ticket.candidate_Name);
        uniqueCandidates.push({
          id: ticket.assignedTo,
          name: ticket.candidate_Name
        });
      }
    });
    
    setCandidates(uniqueCandidates);
  };

  const fetchTickets = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.post(
        `${API_BASE_URL}`,
        { manager_id: user.data[0].emp_id, client_code: user.data[0].client_code },
        { headers: { Authorization: token } }
      );
      
      if (response.data?.status === 200 && response.data?.data) {
        // Transform API data to match component expectations
        const transformedTickets = response.data.data.map(ticket => {
          // Find candidate name from allPodMembers based on assigned_to ID
          const assignedCandidate = allPodMembers.find(member => member.id === ticket.assigned_to);
          
          // Convert ISO date to YYYY-MM-DD format for date input
          const formatDateForInput = (isoDate) => {
            if (!isoDate || isoDate === '0000-00-00') return '';
            try {
              return new Date(isoDate).toISOString().split('T')[0];
            } catch (e) {
              console.error('Error formatting date:', isoDate, e);
              return '';
            }
          };
          
          return {
            id: ticket.ticket_id,
            name: ticket.ticket_name,
            description: ticket.ticket_description,
            type: ticket.ticket_type,
            dueDate: formatDateForInput(ticket.due_date),
            status: ticket.status,
            priority: ticket.ticket_priority?.toLowerCase() || 'medium',
            assignedTo: ticket.assigned_to === 0 ? null : ticket.assigned_to,
            // Use the candidate name from pod members, not from API response
            candidate_Name: ticket.assigned_to === 0 ? null : assignedCandidate?.name || null,
            createdBy: 'Manager',
            createdAt: ticket.created_at,
            managerId: ticket.manager_id,
            clientCode: ticket.client_code
          };
        });
        setTickets(transformedTickets);
      }
    } catch (err) {
      console.error('Error fetching tickets:', err);
      setError('Failed to fetch tickets');
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get candidate name by ID
  const getCandidateNameById = (candidateId) => {
    if (!candidateId) return null;
    const candidate = allPodMembers.find(member => member.id === candidateId) || 
                     candidates.find(c => c.id === candidateId);
    return candidate?.name || null;
  };

  // API function to update ticket
  const updateTicketAPI = async (ticketData) => {
    try {
      setUpdating(true);
      console.log('Updating ticket with data:', ticketData); // Debug log
      
      // Format date for API - convert YYYY-MM-DD to ISO format if needed
      const formatDateForAPI = (dateStr) => {
        if (!dateStr) return null;
        try {
          // If it's already YYYY-MM-DD, convert to ISO
          if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return new Date(dateStr + 'T00:00:00.000Z').toISOString();
          }
          // If it's already ISO, return as-is
          return dateStr;
        } catch (e) {
          console.error('Error formatting date for API:', dateStr, e);
          return dateStr;
        }
      };

      const formattedDueDate = formatDateForAPI(ticketData.dueDate);
      console.log('Original due date:', ticketData.dueDate);
      console.log('Formatted due date for API:', formattedDueDate);
      
      const payload = {
        ticket_id: ticketData.id,
        ticket_name: ticketData.name,
        ticket_description: ticketData.description,
        ticket_type: ticketData.type,
        ticket_priority: ticketData.priority.charAt(0).toUpperCase() + ticketData.priority.slice(1),
        status: ticketData.status,
        due_date: formattedDueDate,
        assigned_to: ticketData.assignedTo || 0,
        assigned_to_name: ticketData.candidate_Name || null // Send candidate name too
      };

      console.log('API payload:', payload); // Debug log

      const response = await axios.put(
        process.env.REACT_APP_TALENT_UPDATETICKETTALENT,
        payload,
        { headers: { Authorization: token } }
      );

      console.log('API response:', response.data); // Debug log

      if (response.data?.status === 200) {
        return { success: true, data: response.data };
      } else {
        throw new Error(response.data?.message || 'Update failed');
      }
    } catch (error) {
      console.error('Error updating ticket:', error);
      throw error;
    } finally {
      setUpdating(false);
    }
  };

  // API function to delete ticket
  const deleteTicketAPI = async (ticketId) => {
    try {
      setUpdating(true);
      const response = await axios.post(
        `${API_BASE_URL}/deleteTicket`,
        { ticket_id: ticketId },
        { headers: { Authorization: token } }
      );

      if (response.data?.status === 200) {
        return { success: true };
      } else {
        throw new Error(response.data?.message || 'Delete failed');
      }
    } catch (error) {
      console.error('Error deleting ticket:', error);
      throw error;
    } finally {
      setUpdating(false);
    }
  };

  const filteredTickets = tickets.filter(ticket => {
    const matchesSearch = ticket.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         ticket.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = !statusFilter || ticket.status === statusFilter;
    const matchesType = !typeFilter || ticket.type === typeFilter;
    
    return matchesSearch && matchesStatus && matchesType;
  });

  const handleEditTicket = (ticket) => {
    console.log('Opening edit dialog for ticket:', ticket); // Debug log
    setSelectedTicket({ ...ticket });
    setEditDialogOpen(true);
  };

  const handleSaveEdit = async () => {
    console.log('Save edit called with selectedTicket:', selectedTicket); // Debug log
    
    if (!selectedTicket) {
      console.log('No selected ticket, aborting save'); // Debug log
      setSnackbarMessage('No ticket selected');
      setSnackbarOpen(true);
      return;
    }

    try {
      console.log('Attempting to save ticket...'); // Debug log
      
      // Update assigned name if assignedTo changed
      const updatedTicket = {
        ...selectedTicket,
        candidate_Name: getCandidateNameById(selectedTicket.assignedTo)
      };
      
      console.log('Updated ticket data:', updatedTicket); // Debug log
      
      // Update via API first
      const result = await updateTicketAPI(updatedTicket);
      console.log('API update result:', result); // Debug log

      // Instead of just updating local state, refetch the tickets to ensure consistency
      // This ensures the data is always in sync with the server
      await fetchTickets();
      
      setSnackbarMessage('Ticket updated successfully');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      setEditDialogOpen(false);
      setSelectedTicket(null);
    } catch (error) {
      console.error('Failed to save ticket:', error); // Debug log
      setSnackbarMessage(`Failed to update ticket: ${error.message}`);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleDeleteTicket = async (ticketId) => {
    try {
      await deleteTicketAPI(ticketId);
      // Refetch tickets after deletion to ensure consistency
      await fetchTickets();
      setSnackbarMessage('Ticket deleted successfully');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } catch (error) {
      setSnackbarMessage('Failed to delete ticket');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'available': return 'success';
      case 'open': return 'info';
      case 'in-progress': return 'warning';
      case 'completed': return 'success';
      case 'on-hold': return 'warning';
      case 'pending': return 'info';
      case 'cancelled': return 'error';
      default: return 'default';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'error';
      case 'medium': return 'warning';
      case 'low': return 'success';
      default: return 'default';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === '0000-00-00') return 'No due date';
    try {
      // If it's already in YYYY-MM-DD format, convert to display format
      if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return new Date(dateString + 'T00:00:00').toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      }
      // If it's an ISO string, convert normally
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (e) {
      console.error('Error formatting date:', dateString, e);
      return 'Invalid date';
    }
  };

  if (loading) {
    return (
      <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
        <Typography variant="h6">Loading tickets...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
        <Button variant="contained" onClick={fetchTickets}>
          Retry
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      {/* Loading overlay for updates */}
      {updating && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}
        >
          <Box
            sx={{
              backgroundColor: 'white',
              p: 3,
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 2
            }}
          >
            <CircularProgress size={24} />
            <Typography>Updating ticket...</Typography>
          </Box>
        </Box>
      )}

      <Box display="flex" alignItems="center" justifyContent="space-between" mb={3}>
        <Box display="flex" alignItems="center" gap={2}>
          <AssignmentIcon color="primary" fontSize="large" />
          <Typography variant="h4" component="h1">
            Ticket Management Dashboard
          </Typography>
        </Box>
        <Button 
          variant="outlined" 
          onClick={fetchTickets} 
          startIcon={<SearchIcon />}
          disabled={updating}
        >
          Refresh
        </Button>
      </Box>
      
      {/* Search and Filter Section */}
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <FilterListIcon color="action" />
          <Typography variant="h6">Filter Tickets</Typography>
        </Box>
        
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Search tickets"
              placeholder="Search by name or description..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                label="Status"
              >
                <MenuItem value="">All Status</MenuItem>
                <MenuItem value="available">Available</MenuItem>
                <MenuItem value="Open">Open</MenuItem>
                <MenuItem value="in-progress">In Progress</MenuItem>
                <MenuItem value="completed">Completed</MenuItem>
                <MenuItem value="on-hold">On Hold</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="cancelled">Cancelled</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel>Type</InputLabel>
              <Select
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
                label="Type"
              >
                <MenuItem value="">All Types</MenuItem>
                <MenuItem value="issue">Issue</MenuItem>
                <MenuItem value="General">General</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      {/* Tickets Table */}
      <TableContainer component={Paper} elevation={2}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: 'primary.main' }}>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Ticket</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Type</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Priority</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Status</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Assigned To</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Due Date</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredTickets.map((ticket) => (
              <TableRow key={ticket.id} hover>
                <TableCell>
                  <Box>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {ticket.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {ticket.description.substring(0, 60)}...
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    {ticket.type === 'issue' ? 
                      <BugReportIcon fontSize="small" color="error" /> : 
                      <EnhancementIcon fontSize="small" color="primary" />
                    }
                    <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>
                      {ticket.type}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell>
                  <Chip 
                    label={ticket.priority.toUpperCase()} 
                    color={getPriorityColor(ticket.priority)}
                    size="small"
                    sx={{ fontWeight: 600 }}
                  />
                </TableCell>
                <TableCell>
                  <Chip 
                    label={ticket.status?.toUpperCase().replace('-', ' ') || 'UNKNOWN'} 
                    color={getStatusColor(ticket.status)}
                    size="small"
                    sx={{ fontWeight: 600 }}
                  />
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    {ticket.candidate_Name ? (
                      <>
                        <PersonIcon fontSize="small" color="primary" />
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {ticket.candidate_Name}
                        </Typography>
                      </>
                    ) : (
                      <>
                        <PersonIcon fontSize="small" color="action" />
                        <Typography variant="body2" color="text.secondary">
                          Unassigned
                        </Typography>
                      </>
                    )}
                  </Box>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {formatDate(ticket.dueDate)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Box display="flex" gap={1}>
                    <Tooltip title="View Details">
                      <IconButton size="small" color="primary" disabled={updating}>
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit Ticket">
                      <IconButton 
                        size="small" 
                        color="secondary"
                        onClick={() => handleEditTicket(ticket)}
                        disabled={updating}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    {/* <Tooltip title="Delete Ticket">
                      <IconButton 
                        size="small" 
                        color="error"
                        onClick={() => handleDeleteTicket(ticket.id)}
                        disabled={updating}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip> */}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {filteredTickets.length === 0 && !loading && (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="h6" color="text.secondary">
            No tickets found matching your criteria
          </Typography>
        </Box>
      )}

      {/* Edit Dialog */}
      <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Edit Ticket</DialogTitle>
        <DialogContent>
          {selectedTicket && (
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Ticket Name"
                  value={selectedTicket.name}
                  onChange={(e) => setSelectedTicket(prev => ({ ...prev, name: e.target.value }))}
                  disabled={updating}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Description"
                  multiline
                  rows={4}
                  value={selectedTicket.description}
                  onChange={(e) => setSelectedTicket(prev => ({ ...prev, description: e.target.value }))}
                  disabled={updating}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Type</InputLabel>
                  <Select
                    value={selectedTicket.type}
                    onChange={(e) => setSelectedTicket(prev => ({ ...prev, type: e.target.value }))}
                    label="Type"
                    disabled={updating}
                  >
                    <MenuItem value="issue">
                      <Box display="flex" alignItems="center" gap={1}>
                        <BugReportIcon fontSize="small" color="error" />
                        Issue
                      </Box>
                    </MenuItem>
                    <MenuItem value="General">
                      <Box display="flex" alignItems="center" gap={1}>
                        <EnhancementIcon fontSize="small" color="primary" />
                        General
                      </Box>
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Priority</InputLabel>
                  <Select
                    value={selectedTicket.priority}
                    onChange={(e) => setSelectedTicket(prev => ({ ...prev, priority: e.target.value }))}
                    label="Priority"
                    disabled={updating}
                  >
                    <MenuItem value="low">Low</MenuItem>
                    <MenuItem value="medium">Medium</MenuItem>
                    <MenuItem value="high">High</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={selectedTicket.status}
                    onChange={(e) => setSelectedTicket(prev => ({ ...prev, status: e.target.value }))}
                    label="Status"
                    disabled={updating}
                  >
                    <MenuItem value="available">Available</MenuItem>
                    <MenuItem value="Open">Open</MenuItem>
                    <MenuItem value="in-progress">In Progress</MenuItem>
                    <MenuItem value="completed">Completed</MenuItem>
                    <MenuItem value="on-hold">On Hold</MenuItem>
                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="cancelled">Cancelled</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Due Date"
                  type="date"
                  value={selectedTicket.dueDate}
                  onChange={(e) => setSelectedTicket(prev => ({ ...prev, dueDate: e.target.value }))}
                  InputLabelProps={{ shrink: true }}
                  disabled={updating}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Assigned To</InputLabel>
                  <Select
                    value={selectedTicket.assignedTo || ''}
                    onChange={(e) => setSelectedTicket(prev => ({ ...prev, assignedTo: e.target.value || null }))}
                    label="Assigned To"
                    disabled={updating || loadingCandidates}
                  >
                    <MenuItem value="">
                      <Box display="flex" alignItems="center" gap={1}>
                        <PersonIcon fontSize="small" color="action" />
                        Unassigned
                      </Box>
                    </MenuItem>
                    {candidates.map((candidate) => (
                      <MenuItem key={candidate.id} value={candidate.id}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <PersonIcon fontSize="small" color="primary" />
                          <Box>
                            <Typography variant="body2">{candidate.name}</Typography>
                            {candidate.podName && (
                              <Typography variant="caption" color="textSecondary">
                                Pod: {candidate.podName}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                  {loadingCandidates && (
                    <Typography variant="caption" color="primary" sx={{ mt: 0.5, ml: 2 }}>
                      Loading candidates...
                    </Typography>
                  )}
                  {candidates.length === 0 && !loadingCandidates && (
                    <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, ml: 2 }}>
                      No candidates available. Check pod configuration.
                    </Typography>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditDialogOpen(false)} disabled={updating}>
            Cancel
          </Button>
          <Button 
            onClick={handleSaveEdit} 
            variant="contained"
            disabled={updating}
            startIcon={updating ? <CircularProgress size={16} /> : null}
          >
            {updating ? 'Saving...' : 'Save Changes'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success/Error Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setSnackbarOpen(false)} 
          severity={snackbarSeverity || 'success'}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};
// ==============================================
// TALENT SIDE COMPONENTS
// ==============================================



export const TalentTicketSearch = ({ onTicketSelect, collapsed,  }) => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [priorityFilter, setPriorityFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const location = useLocation();
  const { user } = useSelector(state => state.auth);
  const token = useAuthToken();
  
  const { podname, podid, viewTab } = location.state || {};

  // Available status transitions
  const statusOptions = [
    { value: 'in-progress', label: 'Start Working', color: 'info' },
    { value: 'completed', label: 'Mark Complete', color: 'success' },
    { value: 'on-hold', label: 'Put On Hold', color: 'warning' },
    { value: 'cancelled', label: 'Cancel', color: 'error' }
  ];

  // Fetch tickets from API
  const fetchTickets = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch(process.env.REACT_APP_CLIENT_FINDTICKETTALENT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
         "Authorization": token 
        },
        body: JSON.stringify({
          pod_id: podid
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.status === 200 && result.data && result.data.tickets) {
        // Transform API data to component format
        const transformedTickets = result.data.tickets.map(ticket => ({
          id: ticket.ticket_id,
          name: ticket.ticket_name,
          description: ticket.ticket_description,
          status: ticket.status,
          type: ticket.ticket_type,
          priority: ticket.ticket_priority.toLowerCase(),
          dueDate: ticket.due_date,
          assignedTo: ticket.assigned_to,
          createdBy: ticket.Candidate_Name || 'Unknown',
          createdAt: ticket.created_at,
          managerId: ticket.manager_id,
          clientCode: ticket.client_code,
          updatedAt: ticket.updated_at
        }));
        
        setTickets(transformedTickets);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (err) {
      console.error('Error fetching tickets:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch tickets on component mount
  useEffect(() => {
    fetchTickets();
  }, [podid]);

  // Filter tickets: show only those assigned to current user OR unassigned (assigned_to = 0 or empty)
  const userTickets = tickets.filter(ticket => {
    const isAssignedToUser = ticket.assignedTo === user.data[0].c_id;
    const isUnassigned = ticket.assignedTo === 0 || ticket.assignedTo === null || ticket.assignedTo === undefined;
    return isAssignedToUser || isUnassigned;
  });
  
  const filteredTickets = userTickets.filter(ticket => {
    const matchesSearch = ticket.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         ticket.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = !typeFilter || ticket.type === typeFilter;
    const matchesPriority = !priorityFilter || ticket.priority === priorityFilter;
    const matchesStatus = !statusFilter || ticket.status === statusFilter;
    
    return matchesSearch && matchesType && matchesPriority && matchesStatus;
  });

  // Check if ticket is assigned to current user
  const isTicketAssignedToUser = (ticket) => {
    return ticket.assignedTo === user.data[0].c_id;
  };

  // Handle picking up unassigned ticket
  const handlePickupTicket = async (ticket) => {
    try {
      setActionLoading(true);
      
      const response = await fetch(process.env.REACT_APP_CLIENT_ASSIGNTICKETTALENT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": token 
        },
        body: JSON.stringify({
          ticket_id: ticket.id,
          assigned_to: user.data[0].c_id,
          status: "in-progress" // Add status payload
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.status === 200) {
        console.log('Ticket assigned successfully, updating local state');
        setTickets(prev => {
          const updated = prev.map(t => 
            t.id === ticket.id 
              ? { ...t, status: 'in-progress', assignedTo: user.data[0].c_id }
              : t
          );
          console.log('Updated tickets:', updated);
          return updated;
        });
        
        setSelectedTicket(ticket);
        setSnackbarOpen(true);
        
        if (onTicketSelect) {
          onTicketSelect(ticket);
        }
      }
    } catch (err) {
      console.error('Error picking up ticket:', err);
      setError(`Failed to pick up ticket: ${err.message}`);
    } finally {
      setActionLoading(false);
    }
  };

  // Handle status change for assigned tickets
  const handleStatusChange = async (ticket, newStatus) => {
    try {
      setActionLoading(true);
      
      const response = await fetch(process.env.REACT_APP_CLIENT_ASSIGNTICKETTALENT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": token 
        },
        body: JSON.stringify({
          ticket_id: ticket.id,
          assigned_to: user.data[0].c_id,
          status: newStatus // Update status
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.status === 200) {
        console.log('Ticket status updated successfully');
        setTickets(prev => {
          const updated = prev.map(t => 
            t.id === ticket.id 
              ? { ...t, status: newStatus }
              : t
          );
          return updated;
        });
        
        setSelectedTicket(ticket);
        setSnackbarOpen(true);
      }
    } catch (err) {
      console.error('Error updating ticket status:', err);
      setError(`Failed to update ticket status: ${err.message}`);
    } finally {
      setActionLoading(false);
    }
  };

  const handleRefresh = () => {
    fetchTickets();
  };

  const getPriorityColor = (priority) => {
    switch (priority?.toLowerCase()) {
      case 'high': return 'error';
      case 'medium': return 'warning';
      case 'low': return 'success';
      default: return 'default';
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'available': return 'success';
      case 'open': return 'info';
      case 'in-progress': return 'warning';
      case 'completed': return 'success';
      case 'on-hold': return 'warning';
      case 'pending': return 'info';
      case 'cancelled': return 'error';
      default: return 'default';
    }
  };

  const getTypeIcon = (type) => {
    return type === 'issue' ? 
      <BugReportIcon color="error" /> : 
      <EnhancementIcon color="primary" />;
  };

  const formatDate = (dateString) => {
    if (dateString === '0000-00-00' || !dateString) return 'No due date';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getDaysUntilDue = (dueDate) => {
    if (dueDate === '0000-00-00' || !dueDate) return null;
    const today = new Date();
    const due = new Date(dueDate);
    const diffTime = due - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  // Loading backdrop
  if (loading) {
    return (
      <Backdrop open={true} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <CircularProgress color="inherit" />
          <Typography>Loading your tickets...</Typography>
        </Box>
      </Backdrop>
    );
  }

  return (
    <Box sx={{ 
      p: 3,
      width: `calc(100vw - ${collapsed ? '60px' : '240px'} - 48px)`,
      marginLeft: collapsed ? '60px' : '240px'
    }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={3}>
        <Box display="flex" alignItems="center" gap={2}>
          <SearchIcon color="primary" fontSize="large" />
          <Typography variant="h4" component="h1">
            My Tickets & Available Tickets
          </Typography>
        </Box>
        <Button 
          variant="outlined" 
          onClick={handleRefresh}
          disabled={loading}
        >
          Refresh
        </Button>
      </Box>
      
      <Alert severity="info" sx={{ mb: 3 }}>
        <Typography variant="body2">
          View your assigned tickets and pick up available tickets to work on. Update status as you progress.
        </Typography>
      </Alert>

      {/* Error Alert */}
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          <Typography variant="body2">
            Error: {error}
          </Typography>
        </Alert>
      )}

      {/* Search and Filter Section */}
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <FilterListIcon color="action" />
          <Typography variant="h6">Search & Filter Tickets</Typography>
        </Box>
        
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Search tickets"
              placeholder="Search by name or description..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth>
              <InputLabel>Type</InputLabel>
              <Select
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
                label="Type"
              >
                <MenuItem value="">All Types</MenuItem>
                <MenuItem value="issue">
                  <Box display="flex" alignItems="center" gap={1}>
                    <BugReportIcon fontSize="small" color="error" />
                    Issue
                  </Box>
                </MenuItem>
                <MenuItem value="General">
                  <Box display="flex" alignItems="center" gap={1}>
                    <EnhancementIcon fontSize="small" color="primary" />
                    General
                  </Box>
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth>
              <InputLabel>Priority</InputLabel>
              <Select
                value={priorityFilter}
                onChange={(e) => setPriorityFilter(e.target.value)}
                label="Priority"
              >
                <MenuItem value="">All Priorities</MenuItem>
                <MenuItem value="high">High Priority</MenuItem>
                <MenuItem value="medium">Medium Priority</MenuItem>
                <MenuItem value="low">Low Priority</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                label="Status"
              >
                <MenuItem value="">All Status</MenuItem>
                <MenuItem value="available">Available</MenuItem>
                <MenuItem value="Open">Open</MenuItem>
                <MenuItem value="in-progress">In Progress</MenuItem>
                <MenuItem value="completed">Completed</MenuItem>
                <MenuItem value="on-hold">On Hold</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="cancelled">Cancelled</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      {/* Results Count */}
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        <strong>{filteredTickets.length}</strong> ticket{filteredTickets.length !== 1 ? 's' : ''} found
      </Typography>

      {/* Tickets Grid */}
      {filteredTickets.length === 0 ? (
        <Paper elevation={1} sx={{ p: 6, textAlign: 'center' }}>
          <AssignmentIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No tickets found
          </Typography>
          <Typography color="text.secondary">
            {userTickets.length === 0 
              ? "You have no assigned tickets and there are no available tickets."
              : "Try adjusting your search or filter criteria"
            }
          </Typography>
        </Paper>
      ) : (
        <Grid container spacing={3}>
          {filteredTickets.map((ticket) => {
            const daysUntilDue = getDaysUntilDue(ticket.dueDate);
            const isUrgent = daysUntilDue !== null && daysUntilDue <= 3;
            const isAssigned = isTicketAssignedToUser(ticket);
            
            return (
              <Grid item xs={12} md={6} lg={4} key={ticket.id}>
                <Card 
                  elevation={2}
                  sx={{ 
                    height: '100%', 
                    display: 'flex', 
                    flexDirection: 'column',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    border: isUrgent ? '2px solid' : isAssigned ? '2px solid' : 'none',
                    borderColor: isUrgent ? 'error.main' : isAssigned ? 'primary.main' : 'transparent',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: 6
                    }
                  }}
                >
                  <CardContent sx={{ flexGrow: 1, p: 3 }}>
                    {/* Header */}
                    <Box display="flex" alignItems="flex-start" justifyContent="space-between" mb={2}>
                      <Box display="flex" alignItems="center" gap={1} flex={1}>
                        {getTypeIcon(ticket.type)}
                        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
                          {ticket.name}
                        </Typography>
                      </Box>
                      <Box display="flex" flexDirection="column" gap={1}>
                        <Chip 
                          label={ticket.priority?.toUpperCase()} 
                          color={getPriorityColor(ticket.priority)}
                          size="small"
                          sx={{ fontWeight: 600 }}
                        />
                        <Chip 
                          label={ticket.status?.toUpperCase()} 
                          color={getStatusColor(ticket.status)}
                          size="small"
                          variant="outlined"
                          sx={{ fontWeight: 600 }}
                        />
                      </Box>
                    </Box>

                    {/* Assignment Status */}
                    {isAssigned && (
                      <Alert severity="info" sx={{ mb: 2 }}>
                        <Typography variant="caption">
                          📋 Assigned to you
                        </Typography>
                      </Alert>
                    )}
                    
                    {/* Urgency Alert */}
                    {isUrgent && (
                      <Alert severity="warning" sx={{ mb: 2 }}>
                        <Typography variant="caption">
                          ⚡ Urgent: Due in {daysUntilDue} day{daysUntilDue !== 1 ? 's' : ''}
                        </Typography>
                      </Alert>
                    )}
                    
                    {/* Description */}
                    <Typography color="text.secondary" paragraph sx={{ lineHeight: 1.6 }}>
                      {ticket.description}
                    </Typography>
                    
                    {/* Tags */}
                    <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
                      <Chip 
                        label={ticket.type === 'issue' ? 'Bug Fix' : 'Feature'} 
                        variant="outlined" 
                        size="small"
                        color={ticket.type === 'issue' ? 'error' : 'primary'}
                      />
                      <Chip 
                        label={`Due: ${formatDate(ticket.dueDate)}`} 
                        variant="outlined" 
                        size="small"
                        icon={<DateRangeIcon />}
                        color={isUrgent ? 'error' : 'default'}
                      />
                    </Box>
                    
                    <Divider sx={{ my: 2 }} />
                    
                    {/* Footer Info */}
                    <Typography variant="caption" color="text.secondary">
                      Created  on {formatDate(ticket.createdAt)}
                    </Typography>
                  </CardContent>
                  
                  {/* Action Buttons */}
                  <Box sx={{ p: 3, pt: 0 }}>
                    {isAssigned ? (
                      // Show status change buttons for assigned tickets
                      <Box display="flex" flexDirection="column" gap={1}>
                        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                          Update Status:
                        </Typography>
                        {statusOptions.map((option) => (
                          <Button
                            key={option.value}
                            fullWidth
                            variant="outlined"
                            size="small"
                            color={option.color}
                            onClick={() => handleStatusChange(ticket, option.value)}
                            disabled={actionLoading || ticket.status === option.value}
                            sx={{ fontWeight: 600 }}
                          >
                            {actionLoading ? (
                              <CircularProgress size={16} color="inherit" />
                            ) : (
                              option.label
                            )}
                          </Button>
                        ))}
                      </Box>
                    ) : (
                      // Show pickup button for unassigned tickets
                      <Button
                        fullWidth
                        variant="contained"
                        size="large"
                        startIcon={<PersonIcon />}
                        onClick={() => handlePickupTicket(ticket)}
                        disabled={actionLoading}
                        sx={{ 
                          fontWeight: 600,
                          backgroundColor: isUrgent ? 'error.main' : 'primary.main',
                          '&:hover': {
                            backgroundColor: isUrgent ? 'error.dark' : 'primary.dark',
                          }
                        }}
                      >
                        {actionLoading ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          isUrgent ? 'Pick Up Urgent Ticket' : 'Pick Up Ticket'
                        )}
                      </Button>
                    )}
                  </Box>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setSnackbarOpen(false)} 
          severity="success"
          variant="filled"
        >
          <Typography variant="body2">
            🎉 Ticket "<strong>{selectedTicket?.name}</strong>" updated successfully!
          </Typography>
        </Alert>
      </Snackbar>
    </Box>
  );
};